module.exports = __webpack_public_path__ + "static/media/Yedige Tlegenov.5bfc38e7.png";